import { TransactionView } from '../../../../../types/entity-types';

export const getAdjacentTransactionsFromFullList = (allTransactions: TransactionView[], currentId: string) => {
  const currentIndex = allTransactions.findIndex((transaction) => transaction.id === currentId);
  if (currentIndex === -1) {
    return { prev: undefined, next: undefined };
  }
  return {
    prev: allTransactions[currentIndex - 1] ?? undefined,
    next: allTransactions[currentIndex + 1] ?? undefined,
  };
};

// Navigate to a transaction by updating URL and dispatching custom event
export const navigateToTransaction = (transactionId: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('id', transactionId);
  searchParams.set('view', 'transaction');
  window.history.pushState({}, '', `?${searchParams.toString()}`);
  window.dispatchEvent(new CustomEvent('transactionNavigate', { detail: { id: transactionId } }));
};

// Handle keyboard navigation for transaction drawer
export const handleTransactionKeyboardNavigation = (
  event: KeyboardEvent,
  isOpen: boolean,
  prev: TransactionView | undefined,
  next: TransactionView | undefined,
) => {
  if (!isOpen) return;

  const key = event.key.toLowerCase();

  if (key === 'arrowup') {
    event.preventDefault();
    if (prev) {
      navigateToTransaction(prev.id);
    }
  } else if (key === 'arrowdown') {
    event.preventDefault();
    if (next) {
      navigateToTransaction(next.id);
    }
  }
};
